import React from 'react'

import { Box, Button, Table, FlexiPagination } from 'flexibull2'
import { ColorBox } from '../components/Styles/ColorBox.style'
import { DropDown } from 'flexibull2/build/dropdown'

const FacultyTable = ({
    faculties,
    onDelete,
    onEdit,
    getFaculties,
    pageNumber,
    setpageNumber,
    orgId,
    setPageOptions,
    pageSize,
    pageSizes,
    pageOptions,
}) => {
    const handlePagination = (page) => {
        getFaculties(pageSize, page, orgId)
        setpageNumber(page)
    }

    const handlePageSize = (pageSize) => {
        getFaculties(pageSize.value, pageNumber, orgId)
        setPageOptions({ ...pageOptions, pageSize: pageSize.value })
    }

    return (
        <div>
            <Box>
                <Box>
                    <Table style={{ paddingTop: '10px' }}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Faculty Title</th>
                                    <th>Short Code</th>
                                    <td>Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                {faculties?.data.map((faculty) => (
                                    <tr key={faculty.id}>
                                        <td>{faculty.faculty_name}</td>
                                        <td>{faculty.short_code}</td>
                                        <td>
                                            <ColorBox>
                                                <DropDown
                                                    label={
                                                        <Button
                                                            pale
                                                            height={20}
                                                            style={{
                                                                border: 'none',
                                                                marginLeft:
                                                                    '-1.5rem',
                                                            }}
                                                        >
                                                            <i className="icon-dot-3" />
                                                        </Button>
                                                    }
                                                    trigger="hover"
                                                    menuAlign="top left"
                                                    menuList={[
                                                        {
                                                            onClick: () =>
                                                                onEdit(faculty),
                                                            label: 'Edit Faculty',
                                                            iconLeft:
                                                                'icon-edit tblue',
                                                        },
                                                        {
                                                            onClick: () =>
                                                                onDelete(
                                                                    faculty.id
                                                                ),
                                                            label: 'Delete Faculty',
                                                            iconLeft:
                                                                'icon-trash tred',
                                                        },
                                                    ]}
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </ColorBox>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Table>
                </Box>
                <Box>
                    <FlexiPagination
                        pageCounts={pageSizes}
                        total={faculties?.totalResults}
                        itemsDisplayed
                        pageSize={pageSize}
                        onChange={handlePagination}
                        changePageSize={handlePageSize}
                        current={pageNumber}
                    />
                </Box>
            </Box>
        </div>
    )
}

export default FacultyTable
